import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { GlobalProvider } from "@/context/GlobalContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import EstructuraOrganizacional from "@/pages/EstructuraOrganizacional";
import ReportView from "@/pages/ReportView";
import UserManagement from "@/pages/UserManagement";
import RolesAdmin from "@/pages/RolesAdmin";
import ParametrosSistema from "@/pages/ParametrosSistema";
import ParametrosOperativos from "@/pages/ParametrosOperativos";
import EnConstruccion from "@/pages/EnConstruccion";
import Cuby from "@/pages/Cuby";
import InventarioCosteo from "@/pages/InventarioCosteo";
import PresupuestoReporte from "@/pages/PresupuestoReporte";
import Campanias from "@/pages/Campanias";
import ComprasGas from "@/pages/ComprasGas";
import ComprasGYP from "@/pages/ComprasGYP";
import ResumenImportar from "@/pages/ResumenImportar";
import ResumenHistorial from "@/pages/ResumenHistorial";
import Home from "@/pages/Home";
import { ANUAL } from "@/lib/resumenConfig";
import PreciosCNE from "@/pages/PreciosCNE";
import { FLETE } from "@/lib/configSemanal";
import PreciosCompra from "@/pages/PreciosCompra";
import ReporteControl from "@/pages/ReporteControl";
import GastoFijo from "@/pages/GastoFijo";
import ProyeccionMensual from "@/pages/ProyeccionMensual";
import { GP_DEF } from "@/lib/gastoFijo";
import { Toaster } from "@/components/ui/sonner";

const wrap = (el, adminOnly = false) => (
  <ProtectedRoute adminOnly={adminOnly}><Layout>{el}</Layout></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <GlobalProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Home />} />
              <Route path="/estructura" element={wrap(<EstructuraOrganizacional />)} />
              <Route path="/reportes/:key" element={wrap(<ReportView />)} />
              <Route path="/z/:key" element={wrap(<EnConstruccion />)} />
              <Route path="/cuby" element={wrap(<Cuby />)} />
              <Route path="/inventarios/costeo" element={wrap(<InventarioCosteo />)} />
              <Route path="/presupuestos/reporte" element={wrap(<PresupuestoReporte />)} />
              <Route path="/campanias" element={wrap(<Campanias />)} />
              <Route path="/contabilidad/compras" element={wrap(<ComprasGas />)} />
              <Route path="/contabilidad/compras-gyp" element={wrap(<ComprasGYP />)} />
              <Route path="/resumen-semanal/importar" element={wrap(<ResumenImportar />)} />
              <Route path="/resumen-semanal/historial" element={wrap(<ResumenHistorial />)} />
              <Route path="/resumen-anual/importar" element={wrap(<ResumenImportar key="anual" cfg={ANUAL} />)} />
              <Route path="/resumen-anual/historial" element={wrap(<ResumenHistorial key="anual-h" cfg={ANUAL} />)} />
              <Route path="/control-semanal/precios-cne" element={wrap(<PreciosCNE />)} />
              <Route path="/control-semanal/precios-pemex" element={wrap(<PreciosCompra />)} />
              <Route path="/control-semanal/precios-flete" element={wrap(<PreciosCompra key="flete" mode={FLETE} />)} />
              <Route path="/control-semanal/reporte" element={wrap(<ReporteControl />)} />
              <Route path="/control-semanal/gasto-fijo" element={wrap(<GastoFijo />)} />
              <Route path="/control-semanal/gestion-planta" element={wrap(<GastoFijo key="gp" def={GP_DEF} />)} />
              <Route path="/control-semanal/proyeccion-mensual" element={wrap(<ProyeccionMensual key="control" vista="control" />)} />
              <Route path="/control-semanal/reporte-control-v2" element={wrap(<ProyeccionMensual key="control_v2" vista="control_v2" />)} />
              <Route path="/control-semanal/proyeccion" element={wrap(<ProyeccionMensual key="proyeccion" vista="proyeccion" />)} />
              <Route path="/usuarios" element={wrap(<UserManagement />, true)} />
              <Route path="/admin/roles" element={wrap(<RolesAdmin />, true)} />
              <Route path="/admin/parametros" element={wrap(<ParametrosSistema />, true)} />
              <Route path="/parametros-operativos" element={wrap(<ParametrosOperativos />)} />
              <Route path="*" element={<Home />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors theme="dark" />
        </GlobalProvider>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
